import { useTranslation } from 'react-i18next';
import {
  ElementsButton,
  SideOverHeading,
  SideOverHeaderNew,
  SideOverHeaderNewProps,
  SideOverFooter,
} from '../components';
import {
  StandardNoteReceivableForm,
  StandardNoteReceivableFormVisibilityOptions,
} from '../../NoteReceivable/components';
import { useNoteReceivableForm } from '../../NoteReceivable/hooks';

export interface EditNoteReceivableFormSideOverPageProps extends Pick<SideOverHeaderNewProps, 'exit'> {
  firmID: string;
  clientID: string;
  visibilityOptions?: StandardNoteReceivableFormVisibilityOptions;
  isLoading?: boolean;
  sideOverHeaderChildren?: React.ReactNode;
  useNoteReceivableFormReturn: ReturnType<typeof useNoteReceivableForm>;
}

export function EditNoteReceivableFormSideOverPage({
  exit,
  firmID,
  clientID,
  isLoading,
  visibilityOptions,
  sideOverHeaderChildren,
  useNoteReceivableFormReturn,
}: EditNoteReceivableFormSideOverPageProps) {
  const { t: tCommon } = useTranslation('common');

  return (
    <>
      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')}>
        {sideOverHeaderChildren}
      </SideOverHeaderNew>
      <div className="px-10">
        <SideOverHeading className="!mt-[25px] mb-14" heading={tCommon('note-receivable')} />
        <StandardNoteReceivableForm
          firmID={firmID}
          clientID={clientID}
          className="mb-36"
          visibilityOptions={visibilityOptions}
          useNoteReceivableFormReturn={useNoteReceivableFormReturn}
        >
          <SideOverFooter>
            <ElementsButton
              size="large"
              icon="check"
              iconPosition="left"
              isLoading={isLoading}
              label={tCommon('save')}
            />
          </SideOverFooter>
        </StandardNoteReceivableForm>
      </div>
    </>
  );
}
